import classnames from "classnames";
import React, { useState } from "react";
import BranchLink from "web/react/components/branch-link/branch-link";
import GenericModal from "web/react/components/generic-modal/generic-modal";
import PaywallMarkup from "web/react/components/paywall-markup/paywall-markup";
import analytics from "web/script/analytics/analytics";
import environment from "web/script/modules/environment";
import { gettext } from "web/script/modules/django-i18n";
import { useSmallBreakpoint } from "web/react/hooks/use-breakpoint/use-breakpoint";
import styles from "./send-to-app-modal.css";

interface SendToAppModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    url: string;
    analyticsEventLabel: string;
    paywalledClassName?: string | null;
    productImageURL?: string | null;
}

function SendToAppModal({
    isOpen,
    onClose,
    title,
    url,
    analyticsEventLabel,
    paywalledClassName,
    productImageURL,
}: SendToAppModalProps): JSX.Element {
    let smallScreen = !useSmallBreakpoint();
    let bottomModal = environment.getFeature("mg_ios_modal_bottom") && smallScreen;
    let [closed, setClosed] = useState(true);

    function handleOpen(): void {
        setClosed(false);
    }
    function onModalClose(): void {
        setClosed(true);
        analytics.event("app_overlay", "modal_dismissed", analyticsEventLabel);
        onClose();
    }

    return (
        <>
            <GenericModal
                isOpen={isOpen}
                onAfterOpen={handleOpen}
                onClose={onModalClose}
                className={classnames({
                    [styles.modal]: bottomModal,
                    [styles.closed]: closed && bottomModal,
                })}
            >
                <div className={styles.content}>
                    <h1 className={styles.title}>{title}</h1>
                    <div className={styles.imgContainer}>
                        {productImageURL && (
                            <img src={productImageURL} className={styles.productImg} />
                        )}
                        <div
                            role="presentation"
                            className={classnames(styles.img, {
                                [styles.smallImg]: productImageURL != null,
                                [styles.largeImg]: productImageURL == null,
                            })}
                        />
                    </div>
                    <BranchLink
                        // "Download the Lyst App for free"
                        title={gettext("feed.show_more.app_overlay.cta")}
                        className={styles.button}
                        branchLink={url}
                        eventLabel={analyticsEventLabel}
                        primaryButton
                    />
                </div>
            </GenericModal>
            {paywalledClassName && <PaywallMarkup cssSelector={paywalledClassName} />}
        </>
    );
}

export default SendToAppModal;
